import type { Schemas } from '@npc/api-client'

import { api } from './api'
import { call } from './errors'

export type ProjectImport = Schemas['ProjectImport']
export type ProjectImportCreated = Schemas['ProjectImportCreated']
export type ProjectImportCreate = Schemas['ProjectImportCreate']
export type ProjectImportOneTime = Schemas['ProjectImportOneTime']
export type ProjectImportClaim = Schemas['ProjectImportClaim']
export type ProjectImportPackage = Schemas['ProjectImportPackage']
export type ProjectImportLink = Schemas['ProjectImportLink']
export type ProjectImportUnlink = Schemas['ProjectImportUnlink']
export type ProjectImportSourceProvisioned = Schemas['ProjectImportSourceProvisioned']
export type ProjectImportSourceOneTime = Schemas['ProjectImportSourceOneTime']
export type ProjectImportAssignmentBundle = Schemas['ProjectImportAssignmentBundle']

export async function createProjectImport(
  input: ProjectImportCreate,
  idempotencyKey?: string,
): Promise<ProjectImportCreated> {
  return call('/project-imports', () =>
    api.POST('/project-imports', {
      body: input,
      ...(idempotencyKey
        ? { params: { header: { 'X-Idempotency-Key': idempotencyKey } } }
        : {}),
    }),
  )
}

export async function assignProjectImport(
  importId: string,
): Promise<ProjectImportAssignmentBundle> {
  return call('/project-imports/{importId}/assignee', () =>
    api.POST('/project-imports/{importId}/assignee', {
      params: { path: { importId } },
    }),
  )
}

/** 按项目读导入草稿。普通项目没有草稿时接口返回 null。 */
export async function getProjectImportByProject(projectId: string): Promise<ProjectImport | null> {
  return call('/projects/{projectId}/import', () =>
    api.GET('/projects/{projectId}/import', { params: { path: { projectId } } }),
  )
}

export async function getProjectImport(importId: string): Promise<ProjectImport> {
  return call('/project-imports/{importId}', () =>
    api.GET('/project-imports/{importId}', { params: { path: { importId } } }),
  )
}

export async function submitProjectImportPackage(
  submitToken: string,
  body: ProjectImportPackage,
): Promise<ProjectImport> {
  return call('/public/project-imports/{submitToken}/package', () =>
    api.POST('/public/project-imports/{submitToken}/package', {
      params: { path: { submitToken } },
      body,
    }),
  )
}

export async function approveProjectImport(importId: string, claimKeys: string[]): Promise<ProjectImport> {
  return call('/project-imports/{importId}/approve', () =>
    api.POST('/project-imports/{importId}/approve', {
      params: { path: { importId } },
      body: { claim_keys: claimKeys },
    }),
  )
}

export async function unlinkProjectImport(
  importId: string,
  body: ProjectImportUnlink,
): Promise<ProjectImport> {
  return call('/project-imports/{importId}/unlink', () =>
    api.POST('/project-imports/{importId}/unlink', {
      params: { path: { importId } },
      body,
    }),
  )
}

export async function reissueProjectImportPackage(importId: string): Promise<ProjectImportCreated> {
  return call('/project-imports/{importId}/package/reissue', () =>
    api.POST('/project-imports/{importId}/package/reissue', {
      params: { path: { importId } },
    }),
  )
}
